import React, { FC } from 'react';
import { TableCell, TableRow } from '@material-ui/core';

interface IProps {
  height: number;
  colSpan: number;
}

const DummyTableRow: FC<IProps> = ({ height, colSpan }) => (
  <TableRow style={{ height }}>
    <TableCell colSpan={colSpan} />
  </TableRow>
);

export default DummyTableRow;
